var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCurrencyEuro = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "currency-euro_svg__a",
  width: 40,
  height: 40,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M0 0h40v40H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#000",
  mask: "url(#currency-euro_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.333 33.333V6.667h33.334v26.666H3.333Zm2.778-2.778H33.89V9.445H6.11v21.11Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.72 23.42c-.4.35-.88.64-1.43.84-.55.2-1.12.31-1.71.31-.92 0-1.77-.24-2.52-.71-.63-.4-1.14-.9-1.52-1.51h4.29v-2.06h-5.02c0-.06-.02-.11-.02-.17-.01-.11-.02-.23-.02-.36 0-.13 0-.25.02-.36 0-.05.01-.11.02-.17h5.02v-2.06h-4.29c.38-.61.89-1.12 1.52-1.51.75-.47 1.6-.71 2.52-.71.59 0 1.16.1 1.69.3.54.2 1.03.49 1.46.84l.17.15 1.71-1.71-.19-.18a6.9 6.9 0 0 0-2.21-1.37c-.82-.32-1.71-.48-2.63-.48-1.58 0-3 .45-4.23 1.35a7.246 7.246 0 0 0-2.55 3.32H12v2.06h2.34v1.06H12v2.06h2.8a7.313 7.313 0 0 0 2.55 3.32c1.23.9 2.65 1.35 4.23 1.35.92 0 1.81-.16 2.63-.48.82-.32 1.56-.78 2.21-1.37l.19-.18-1.71-1.71-.18.16v-.02Z"
}))));
export default SvgCurrencyEuro;